module.exports = __webpack_public_path__ + "sprite/win-sign@2x.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/win-sign@2x.json
// module id = 131
// module chunks = 3